(function () {
  var source = document.getElementById('drool-edit-spots-source');
  if (!source) return;                       // not an edit collection -> exit

  // Take the pre-rendered spot nodes out of the hidden source (once).
  var spots = Array.prototype.slice.call(source.querySelectorAll('.edit-spot'));
  if (!spots.length) return;
  spots.forEach(function (s) { s.parentNode.removeChild(s); });

  // F4.1 — utm-gated ad spots. utm_term is a '__'-separated segment string (AF_..., CR_Alex L,
  // O_EndOfSummer40, ...). A node carrying data-utm-match belongs to an Ad Partnerships entry
  // whose utm_match field lists one or more of those segments; the node participates only when
  // the visitor's utm_term contains EVERY listed segment, and when several entries match, the
  // most specific one (most segments) wins outright — only its spots are placed. An active ad
  // spot also takes precedence over a collection spot at the SAME position — the collection
  // spot is dropped for this visitor only. No utm_term, or no match, leaves the collection
  // spots exactly as before; filtered-out nodes are already detached above.
  // Must stay in step with the same logic in the inline gate in edit-spots.liquid.
  function normSegs(value) {
    var out = [];
    var parts = String(value || '').split('__');
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].trim().toLowerCase();
      if (p) out.push(p);
    }
    return out;
  }
  // The utm_term persists for the tab session, scoped to the path it was first seen on, so a
  // visitor who browses away and returns to this page gets the ad content again. Latest term
  // wins. Key shared with wd-ig-attribution (the handle strip). Storage failures (private
  // mode) fall back to URL-only behaviour.
  var utmSegs = {};
  try {
    var utmTerm = null;
    try { utmTerm = new URLSearchParams(window.location.search).get('utm_term'); } catch (e) {}
    try {
      if (utmTerm) {
        sessionStorage.setItem('wd_ad_utm', JSON.stringify({ t: utmTerm, p: window.location.pathname }));
      } else {
        var storedTerm = JSON.parse(sessionStorage.getItem('wd_ad_utm') || 'null');
        if (storedTerm && storedTerm.p === window.location.pathname) utmTerm = storedTerm.t;
      }
    } catch (e) { /* storage unavailable */ }
    var have = normSegs(utmTerm);
    for (var h = 0; h < have.length; h++) utmSegs[have[h]] = true;
  } catch (e) { /* no URLSearchParams -> ad spots stay off */ }

  function matchCount(node) {
    var attr = node.getAttribute('data-utm-match');
    if (attr === null) return -1;               // collection spot, not an ad node
    var req = normSegs(attr);
    if (!req.length) return 0;
    for (var i = 0; i < req.length; i++) {
      if (!utmSegs[req[i]]) return 0;
    }
    return req.length;
  }

  var bestKey = '';
  var bestCount = 0;
  spots.forEach(function (s) {
    var count = matchCount(s);
    if (count > bestCount) {
      bestCount = count;
      bestKey = normSegs(s.getAttribute('data-utm-match')).join('__');
    }
  });

  var adPositions = {};
  spots = spots.filter(function (s) {
    var attr = s.getAttribute('data-utm-match');
    if (attr === null) return true;             // collection spot: always participates
    if (!bestKey || normSegs(attr).join('__') !== bestKey || matchCount(s) < 1) return false;
    adPositions[parseInt(s.getAttribute('data-position'), 10) || 0] = true;
    return true;
  });
  spots = spots.filter(function (s) {
    if (s.getAttribute('data-utm-match') !== null) return true;
    return !adPositions[parseInt(s.getAttribute('data-position'), 10) || 0];
  });

  // Everything below (slot ownership, placement, balancing, the re-render watch) sees only the
  // spots that survived the filter. All gone -> behave exactly like a collection with no spots.
  if (!spots.length) return;

  // Viewport-scoped spots. Liquid marks an entry data-wd-viewport when it has art for one
  // viewport only and cannot stand in at the other: any mobile-only entry, and a full-width
  // (row-spanning) desktop-only one. A single-cell desktop-only spot is left unmarked, because
  // a card-shaped tile works at both widths.
  // The node is filtered out of the spots array rather than hidden with CSS: a display:none
  // cell still measures as a cell in balance(), and misplaced() would report it out of place
  // forever, re-running place() in a loop. Same shape as the utm gate above.
  // Keep 749px in step with the <source media> in edit-spots.liquid.
  var VIEWPORT_MQ = '(max-width: 749px)';
  var allSpots = spots;
  function viewportOk(spot) {
    var want = spot.getAttribute('data-wd-viewport');
    if (!want) return true;                   // both images, or neither -> every viewport
    var mobile = !!(window.matchMedia && window.matchMedia(VIEWPORT_MQ).matches);
    return want === (mobile ? 'mobile' : 'desktop');
  }
  function applyViewport() { spots = allSpots.filter(viewportOk); }
  // Runs before placement, so a mobile-only position-0 spot does not claim the reserved first
  // cell on desktop.
  applyViewport();

  // Crossing the breakpoint (resize, rotate) changes which spots qualify. place() clears every
  // .edit-spot out of the grid before re-inserting, so a node that no longer qualifies is taken
  // out and one that now does is put back.
  if (window.matchMedia) {
    var viewportMq = window.matchMedia(VIEWPORT_MQ);
    var onViewportChange = function () { applyViewport(); place(); };
    if (viewportMq.addEventListener) viewportMq.addEventListener('change', onViewportChange);
    else if (viewportMq.addListener) viewportMq.addListener(onViewportChange);  // Safari < 14
  }

  // Kept for plp-content-spot.js (the old Build Your Bundle section, switched off and Boost-only):
  // tells it a position-0 edit spot owns the first cell.
  window.droolEditSpotOwnsSlot = spots.some(function (s) {
    return (parseInt(s.getAttribute('data-position'), 10) || 0) === 0;
  });

  // The theme's own collection grid (main-collection.liquid -> snippets/product-grid.liquid) since
  // Boost was removed on 17 Oct 2026. Scoped to the main collection section: the product-list
  // sections further down the page use the same ul.product-grid class.
  function gridEl() {
    return document.querySelector('.main-collection-grid ul.product-grid');
  }

  // A real product card cell. Our cells (the reserved first cell, the wrappers below) carry no
  // data-product-id. Cards wd-plp-pin.js hides take no cell, so they are not counted either.
  function isProduct(node) {
    return node.nodeType === 1 &&
           node.hasAttribute('data-product-id') &&
           !node.classList.contains('wd-plp-pin--duplicate') &&
           !node.classList.contains('wd-plp-pin--displaced');
  }

  function productsIn(list) {
    return Array.prototype.filter.call(list.children, isProduct);
  }

  // The products in the grid, in order, with the ones balance() hid marked. Recorded at the end of
  // every place(); a different value means products were added (next page), replaced (filter,
  // sort) or un-hidden by a re-render, so the last-row trimming is stale even when every spot is
  // still in place. Without this, the cards hidden at the end of page 1 stay hidden in the middle
  // of the grid once page 2 loads.
  var lastGridKey = '';
  function gridKey(items) {
    return items.map(function (n) {
      return n.getAttribute('data-product-id') + (n.classList.contains('edit-spot-displaced') ? 'h' : '');
    }).join(',');
  }

  // Each product cell carries the page it came from (data-page) and the grid the total
  // (data-last-page). Infinite scroll appends a page at a time, so a position past the last loaded
  // product usually just hasn't loaded yet; only once the last page is in is it genuinely
  // unreachable.
  function loadedPages(items) {
    if (!items.length) return { first: 1, last: 1 };
    return {
      first: parseInt(items[0].getAttribute('data-page'), 10) || 1,
      last: parseInt(items[items.length - 1].getAttribute('data-page'), 10) || 1
    };
  }
  function moreToLoad(list, items) {
    var lastPage = parseInt(list.getAttribute('data-last-page'), 10) || 1;
    return loadedPages(items).last < lastPage;
  }

  // The first cell main-collection.liquid reserves (snippets/wd-grid-spot-slot.liquid). It is only
  // there on page 1 and only when the collection has a position-0 spot this visitor can see.
  function slotOf(list) {
    return list.querySelector(':scope > .wd-grid-spot--slot');
  }
  // Whether the reserved cell is shown at this viewport, read from the classes Liquid set rather
  // than measured, so a cell hidden by a previous pass (.is-unused) still counts as open.
  function slotOpen(slot) {
    var mobile = !!(window.matchMedia && window.matchMedia(VIEWPORT_MQ).matches);
    return slot.classList.contains(mobile ? 'wd-grid-spot--m' : 'wd-grid-spot--d');
  }

  // Shape of the cell a spot sits in. Liquid guessed the reserved cell's shape from the
  // collection's own spot; the spot actually placed (an ad spot can replace it) has the last word.
  // Ad spots carry their image ratios, so a full-width ad banner gets its own aspect ratio.
  function shapeCell(cell, spot) {
    var full = spot.classList.contains('edit-spot--full');
    cell.classList.toggle('is-full', full);
    cell.classList.toggle('is-single', !full);
    var ratio = spot.getAttribute('data-wd-ratio');
    var ratioMobile = spot.getAttribute('data-wd-ratio-mobile');
    if (ratio) cell.style.setProperty('--wd-spot-ratio', ratio);
    if (ratioMobile) cell.style.setProperty('--wd-spot-ratio-m', ratioMobile);
  }

  // Every spot not in the reserved cell goes into one of these grid cells. The id is unique and
  // stable so a filter re-render (the section morph keys on id) never morphs our cell into a
  // product card: an unkeyed cell next to an unkeyed new node would be reused in place.
  // data-wd-spot-cell is what tells place() the cell is ours to remove.
  var cellCount = 0;
  function cellFor(spot) {
    if (spot.wdCell) return spot.wdCell;
    var cell = document.createElement('li');
    cell.className = 'product-grid__item wd-grid-spot wd-grid-spot--cell';
    cell.id = 'wd-grid-spot-' + (++cellCount);
    cell.setAttribute('data-wd-spot-cell', '');
    shapeCell(cell, spot);
    cell.appendChild(spot);
    spot.wdCell = cell;
    return cell;
  }

  function place() {
    var list = gridEl();
    if (!list) return;
    // Detach everything placed on the previous pass. Removing our cell takes its spot with it;
    // a spot in the reserved cell is lifted out on its own, because that cell is the server's.
    Array.prototype.forEach.call(list.querySelectorAll('.edit-spot'), function (n) {
      var cell = n.parentNode;
      if (cell && cell.hasAttribute && cell.hasAttribute('data-wd-spot-cell')) cell.remove();
      else n.remove();
    });
    // Un-hide products hidden on a previous pass: the product set (and so which ones are "last")
    // changes on every filter, sort and page load.
    Array.prototype.forEach.call(list.querySelectorAll('.edit-spot-displaced'), function (n) {
      n.classList.remove('edit-spot-displaced');
    });

    var items = productsIn(list);
    // Landed on a later page (?page=3, e.g. back from a product page): the products before it are
    // not on the page yet, so "after product #pos" cannot be counted. Place nothing until the
    // earlier pages have been loaded in above (the watch below re-runs this when they are).
    if (loadedPages(items).first > 1) { watch(); return; }

    var atEnd = !moreToLoad(list, items);
    var placed = [];
    var slot = slotOf(list);
    var slotFree = !!(slot && slotOpen(slot));
    if (slot) slot.classList.remove('is-full', 'is-single', 'is-unused');

    spots.forEach(function (spot) {
      var pos = parseInt(spot.getAttribute('data-position'), 10) || 0;  // AFTER product #pos
      // Straight into the reserved, already-sized first cell: no product moves. Deliberately not
      // pushed to `placed`: balance() counts the reserved cell on its own.
      if (pos === 0 && slotFree) {
        slot.appendChild(spot);
        shapeCell(slot, spot);
        slotFree = false;
        return;
      }
      var node = cellFor(spot);
      var ref = items[pos];                     // element that follows product #pos (0-based)
      if (ref) { list.insertBefore(node, ref); }
      // pos beyond the last LOADED product: hold the spot back rather than dropping it at the end
      // of the current page, where it would show up early and in the wrong place until its page
      // loads. Falls to the end of the grid only once nothing more can load.
      else if (atEnd) { list.appendChild(node); }
      else { return; }
      placed.push(node);
    });

    // No spot qualified for the reserved cell (e.g. an ad spot took position 0 in its place but is
    // for the other viewport): hide the cell rather than leave a blank card.
    if (slot && !slot.childElementCount) slot.classList.add('is-unused');

    balance(list, items, placed, slot);
    lastGridKey = gridKey(items);
    watch();
  }

  // Widest row in the grid = the column count. Measured rather than taken from a breakpoint
  // table, because the grid uses auto-fill columns; taking the LARGEST row keeps it right even
  // when a full-width spot sits alone on a row.
  function columnsOf(list) {
    var kids = list.children;
    var rows = {};
    var cols = 1;
    var rowCount = 0;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].offsetParent === null) continue;   // display:none -> not on a row
      var top = Math.round(kids[i].offsetTop);
      if (!rows[top]) rowCount++;
      rows[top] = (rows[top] || 0) + 1;
      if (rows[top] > cols) cols = rows[top];
    }
    // One row only: the widest row is also the shortest, so the count above is the number of
    // products, not the column count. Nothing can overflow a row that never wraps.
    return rowCount > 1 ? cols : 0;
  }

  // Keep the grid a clean rectangle: the last row is either full or empty. Anything a content
  // spot pushed past the last complete row is hidden, rather than left as a stub row of one or two
  // cards. Counts every occupied cell: products, our cells, and the reserved cell when it holds a
  // spot. Class toggles don't fire the observer, so this cannot loop.
  function balance(list, items, placed, slot) {
    var cols = columnsOf(list);
    if (cols < 2) return;                       // single column: nothing can overflow a row
    var slotUsed = !!(slot && slot.childElementCount);
    // Nothing of ours is in the grid: no displacement to make up for.
    if (!placed.length && !slotUsed) return;
    var listWidth = list.getBoundingClientRect().width;
    var cells = items.length;
    // A cell that actually spans the row takes a whole row, so it shifts nothing. Measured, not
    // read from the class.
    placed.forEach(function (cell) {
      cells += cell.getBoundingClientRect().width < listWidth * 0.9 ? 1 : cols;
    });
    if (slotUsed) {
      cells += slot.getBoundingClientRect().width < listWidth * 0.9 ? 1 : cols;
    }
    var overflow = cells % cols;
    for (var i = items.length - 1; overflow > 0 && i >= 0; i--, overflow--) {
      items[i].classList.add('edit-spot-displaced');
    }
  }

  // True when a re-render dropped a spot, or products were added or removed around it so it no
  // longer sits after product #pos. Gates the observer so place()'s own inserts (which mutate the
  // grid and re-fire the observer) can't loop.
  function misplaced(list) {
    var items = productsIn(list);
    var pages = loadedPages(items);
    if (pages.first > 1) return false;          // place() waits for the earlier pages
    if (gridKey(items) !== lastGridKey) return true;
    var slot = slotOf(list);
    // A new reserved cell (a re-render that brought page 1 back) that nobody has decided on yet.
    if (slot && !slot.childElementCount && !slot.classList.contains('is-unused')) return true;
    var total = items.length;
    var atEnd = !moreToLoad(list, items);
    for (var i = 0; i < spots.length; i++) {
      var spot = spots[i];
      var pos = parseInt(spot.getAttribute('data-position'), 10) || 0;
      if (slot && spot.parentNode === slot) continue;   // in the reserved cell: in place
      // Same rule place() applies: a spot whose page hasn't loaded is SUPPOSED to be out of the
      // grid. Without this the parentNode check below would report it misplaced on every grid
      // mutation and re-run place() in a loop.
      var node = spot.wdCell;
      if (pos >= total && !atEnd) {
        if (node && node.parentNode === list) return true;
        continue;
      }
      if (!node || node.parentNode !== list || spot.parentNode !== node) return true;
      var want = pos > total ? total : pos;     // pos beyond last -> expected at end of grid
      var before = 0;
      for (var n = node.previousElementSibling; n; n = n.previousElementSibling) {
        if (isProduct(n)) before++;
      }
      if (before !== want) return true;
    }
    return false;
  }

  // Re-place after the grid changes. The theme fires no event after it changes the grid: a filter
  // or sort morphs the section (wd-collection-filters.js -> sectionRenderer) and infinite scroll
  // appends or prepends a page (paginated-list.js) silently. So this watches the results list for
  // added or removed nodes, and misplaced() decides whether anything needs doing.
  var observer = null;
  function watch() {
    if (observer) return;
    var root = document.querySelector('results-list') || document.body;
    observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes.length && !m.removedNodes.length) continue;
        // Skip mutations we caused inside a spot cell.
        if (m.target && m.target.closest && m.target.closest('.wd-grid-spot')) continue;
        var list = gridEl();
        if (list && misplaced(list)) place();
        return;
      }
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  // This script loads right after the grid (edit-spots renders below main-collection), so the grid
  // is normally already parsed. The DOMContentLoaded path covers a template that orders it the
  // other way.
  if (gridEl()) place();
  else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { place(); watch(); });
  } else {
    watch();
  }
})();
